import { gql } from "apollo-boost"

export const upsertConsultants = gql`
mutation UpsertConsultants(
  $submissionId: String!
  $consultants: [CreateConsultantInput!]!
) {
  UpsertConsultants(
    submissionId: $submissionId
    consultants: $consultants
  )
}
`